import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const handleAuth = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          console.log('Authentication successful:', response);
        }
        
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        setIsProcessing(false);
        navigate('/');
      } catch (error) {
        console.error('Authentication failed:', error);
        setIsProcessing(false);
        navigate('/');
      }
    };

    handleAuth();
  }, [instance, navigate]);

  if (isProcessing) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="inline-block w-8 h-8 border-2 border-border-secondary border-t-semantic-info rounded-full animate-spin"></div>
      </div>
    );
  }

  return null;
};

export default AuthCallback;
